export const TIER_TYPES = {
  Quantity: "Quantity",
  Price: "Price",
};
